import Sidebar from "../../components/sidebar/Sidebar";
import "./home.scss";
import FullScreenMap from "../../components/map/FullScreenMap";
import React, { useEffect, useState } from "react";
import Dashboard from "../../components/Dashboard/Dashboard";
import { useAuth } from "../../context/AuthContext";
import MachineBoard from "../../board/MachineBoard";

// Legacy render path: the original alarm-map / rotating-dashboard / sidebar board.
// Unchanged behavior for agencies still on the shared per-agency account.
const LegacyBoard = () => {
  const [selectedTab, setSelectedTab] = useState("map");
  const [alarms, setAlarms] = useState([]);

  useEffect(() => {
    setSelectedTab(alarms.length > 0 ? "map" : "dashboard");
  }, [alarms]);

  return (
    <div className="homeContainer">
      <FullScreenMap
        alarms={alarms}
        setAlarms={setAlarms}
        onAlarmsChange={setAlarms}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <Dashboard selectedTab={selectedTab} />
      <Sidebar />
    </div>
  );
};

const Home = () => {
  const { mode } = useAuth();

  // Render a board only once the account has been resolved. `mode` is null
  // right after sign-in (claims are still being checked); treating that as
  // legacy briefly mounted the legacy board for new board accounts, whose
  // components then read a users/{uid} profile those accounts don't have.
  return (
    <div className="home">
      {mode === "machine" ? (
        <MachineBoard />
      ) : mode === "legacy" ? (
        <LegacyBoard />
      ) : (
        <div className="sb-stage-bg" style={{ background: "#0b0b0d" }}>
          <div className="sb-board-waiting">Connecting…</div>
        </div>
      )}
    </div>
  );
};

export default Home;
